import { useCallback, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";

/**
 * Die offene Unterhaltung steht im Pfad (`/chat/<id>`): so zeigen Sidebar und Inhalt
 * dasselbe, und der Link auf eine Unterhaltung lässt sich verschicken.
 */
export interface ChatLocation {
  channelId: string | null;
  openChannel: (channelId: string) => void;
}

export function useChatLocation(): ChatLocation {
  const { channelId } = useParams<{ channelId: string }>();
  const navigate = useNavigate();

  const openChannel = useCallback(
    (next: string) => {
      navigate(`/chat/${next}`);
    },
    [navigate],
  );

  return useMemo(() => ({ channelId: channelId ?? null, openChannel }), [channelId, openChannel]);
}
